module.exports = __webpack_public_path__ + "capricorn-7bbb863647b9b21bb407.png";